import React from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { FloatingButtons } from "./FloatingButtons";
import { CartDrawer } from "./CartDrawer";
import ScrollToTop from "./ScrollToTop";

export const Layout = () => (
  <div className="min-h-screen flex flex-col bg-cream">
    <ScrollToTop />
    <Navbar />
    <main className="flex-1">
      <Outlet />
    </main>
    <Footer />
    <FloatingButtons />
    <CartDrawer />
  </div>
);
